import $ from "jquery";
// import anime from "animejs/lib/anime.es.js";

export const heroBanner = () => {
  const elms = {
    bannerHighlight: ".animatedBanner__title",
  };

  function highlightPosition() {
    $(elms.bannerHighlight).each(function() {
      const $this = $(this);
      const word = $this.find("b");
      const wordText = word.text();
      const wordHeight = word.outerHeight();
      const unit = wordHeight/4;
      // const $text = $this.siblings(".animatedBanner__titleDisplay");
      // const marginRight = word.outerWidth() - wordHeight + (unit*2);
      // const spanStyle = 'display: inline; opacity: 0;vertical-align: bottom;';
      // const highlightStyle = 'display: inline-block; overflow: hidden;max-height:1em;white-space: nowrap;padding:0 '+unit+'px 0 '+unit+'px; margin-right:'+marginRight+'px;max-width: 1em;border-radius: 1em; vertical-align: bottom;';

      if (word.length > 0) {
        $this.animate({
          opacity: 1
        }, 500);
        word.html('<span class="animatedBanner__highlight-box"></span><span class="animatedBanner__highlight-text">'+wordText+'</span>');
  
        word.css("padding", "0 "+unit+"px");

        setTimeout(function() {
          word.children(".animatedBanner__highlight-box").animate({
            width: "100%",
            opacity: 1,
          }, 500)
        }, 500);

      } else {        
        $this.animate({
          opacity: 1
        }, 300);
      }

    }) 
  }

  $(window).on("load", function () {
    highlightPosition();
  });
};
